var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var hashes = {};
var processingFMCloudTransaction = {
    isProcessing: false,
    TTL: 5000,
    start: function () {
        var _this = this;
        this.isProcessing = true;
        setTimeout(function () {
            _this.isProcessing = false;
        }, this.TTL);
    },
    end: function () {
        this.isProcessing = false;
    },
};
/**
 * Tells the AccountView to load itself onto the dom
 * @param {TransactionRequest} txn
 */
function processAccount(txn) {
    var _a;
    var isRollback = ((_a = txn === null || txn === void 0 ? void 0 : txn.options) === null || _a === void 0 ? void 0 : _a.rollback) || false;
    // fetch 1stmile-account.js if needed
    var scriptSrc = "".concat(env.PROCESS_ENDPOINT, "/js/").concat(isRollback ? 'prev/' : '', "1stmile-account.js");
    var scripts = document.querySelectorAll('#firstmile-account');
    var isLoaded = false;
    scripts.forEach(function (script) {
        if (script.src === scriptSrc)
            isLoaded = true;
    });
    if (!isLoaded) {
        var script = document.createElement('script');
        script.id = 'firstmile-account';
        script.src = scriptSrc;
        script.crossOrigin = 'anonymous';
        script.integrity = isRollback
            ? hashes.prev['1stmile-account.js']
            : hashes['1stmile-account.js'];
        script.addEventListener('load', function () {
            // wait for the script to finish loading before showing the account view
            FirstMileAccountView.show(txn);
        });
        document.head.appendChild(script);
    }
    else {
        // AccountView is already defined
        // show the account view
        FirstMileAccountView.show(txn);
    }
}
/**
 * Tells the ApplyView to load itself onto the dom
 * @param {TransactionRequest} txn
 */
function processApply(txn) {
    var _a;
    var isRollback = ((_a = txn === null || txn === void 0 ? void 0 : txn.options) === null || _a === void 0 ? void 0 : _a.rollback) || false;
    // fetch 1stmile-apply.js if needed
    var scriptSrc = "".concat(env.PROCESS_ENDPOINT, "/js/").concat(isRollback ? 'prev/' : '', "1stmile-apply.js");
    var scripts = document.querySelectorAll('#firstmile-apply');
    var isLoaded = false;
    scripts.forEach(function (script) {
        if (script.src === scriptSrc)
            isLoaded = true;
    });
    if (!isLoaded) {
        var script = document.createElement('script');
        script.id = 'firstmile-apply';
        script.src = scriptSrc;
        script.crossOrigin = 'anonymous';
        script.integrity = isRollback
            ? hashes.prev['1stmile-apply.js']
            : hashes['1stmile-apply.js'];
        script.addEventListener('load', function () {
            // wait for the script to finish loading before showing the apply view
            FirstMileApplyView.show(txn);
        });
        document.head.appendChild(script);
    }
    else {
        // ApplyView is already defined
        // show the apply view
        FirstMileApplyView.show(txn);
    }
}
/**
 * Tells the CreditFacility to load itself onto the dom
 * @param {TransactionRequest} txn
 */
function processCreditFacility(txn) {
    var _a;
    var isRollback = ((_a = txn === null || txn === void 0 ? void 0 : txn.options) === null || _a === void 0 ? void 0 : _a.rollback) || false;
    // fetch 1stmile-creditfacility.js if needed
    var scriptSrc = "".concat(env.PROCESS_ENDPOINT, "/js/").concat(isRollback ? 'prev/' : '', "1stmile-creditfacility.js");
    var scripts = document.querySelectorAll('#firstmile-creditfacility');
    var isLoaded = false;
    scripts.forEach(function (script) {
        if (script.src === scriptSrc)
            isLoaded = true;
    });
    if (!isLoaded) {
        var script = document.createElement('script');
        script.id = 'firstmile-creditfacility';
        script.src = scriptSrc;
        script.crossOrigin = 'anonymous';
        script.integrity = isRollback
            ? hashes.prev['1stmile-creditfacility.js']
            : hashes['1stmile-creditfacility.js'];
        script.addEventListener('load', function () {
            // wait for the script to finish loading before showing the credit facility view
            FirstMileCreditFacilityView.show(txn);
        });
        document.head.appendChild(script);
    }
    else {
        // CreditFacilityView is already defined
        // show the CreditFacility view
        FirstMileCreditFacilityView.show(txn);
    }
}
/**
 * Tells the SaleView to load itself onto the dom
 * @param {TransactionRequest} txn
 */
function processSale(txn) {
    var _a;
    var isRollback = ((_a = txn === null || txn === void 0 ? void 0 : txn.options) === null || _a === void 0 ? void 0 : _a.rollback) || false;
    // fetch 1stmile-sale.js if needed
    var scriptSrc = "".concat(env.PROCESS_ENDPOINT, "/js/").concat(isRollback ? 'prev/' : '', "1stmile-sale.js");
    var scripts = document.querySelectorAll('#firstmile-sale');
    var isLoaded = false;
    scripts.forEach(function (script) {
        if (script.src === scriptSrc)
            isLoaded = true;
    });
    if (!isLoaded) {
        var script = document.createElement('script');
        script.id = 'firstmile-sale';
        script.src = scriptSrc;
        script.crossOrigin = 'anonymous';
        script.integrity = isRollback
            ? hashes.prev['1stmile-sale.js']
            : hashes['1stmile-sale.js'];
        script.addEventListener('load', function () {
            // wait for the script to finish loading before showing the sale view
            FirstMileSaleView.show(txn);
        });
        document.head.appendChild(script);
    }
    else {
        // SaleView is already defined
        // show the sale view
        FirstMileSaleView.show(txn);
    }
}
/**
 * Tells the Credit view to load itself
 * @param {TransactionRequest} txn
 */
function processCredit(txn) {
    var _a;
    var isRollback = ((_a = txn === null || txn === void 0 ? void 0 : txn.options) === null || _a === void 0 ? void 0 : _a.rollback) || false;
    // fetch 1stmile-credit.js if needed
    var scriptSrc = "".concat(env.PROCESS_ENDPOINT, "/js/").concat(isRollback ? 'prev/' : '', "1stmile-credit.js");
    var scripts = document.querySelectorAll('#firstmile-credit');
    var isLoaded = false;
    scripts.forEach(function (script) {
        if (script.src === scriptSrc)
            isLoaded = true;
    });
    if (!isLoaded) {
        var script = document.createElement('script');
        script.id = 'firstmile-credit';
        script.src = scriptSrc;
        script.crossOrigin = 'anonymous';
        script.integrity = isRollback
            ? hashes.prev['1stmile-credit.js']
            : hashes['1stmile-credit.js'];
        script.addEventListener('load', function () {
            // wait for the script to finish loading before showing the credit view
            FirstMileCreditView.show(txn);
        });
        document.head.appendChild(script);
    }
    else {
        // Credit is already defined
        // show the Credit view
        FirstMileCreditView.show(txn);
    }
}
/**
 * Tells the Txn view to load itself
 * @param {TransactionRequest} txn
 */
function processTxn(txn) {
    var _a;
    var isRollback = ((_a = txn === null || txn === void 0 ? void 0 : txn.options) === null || _a === void 0 ? void 0 : _a.rollback) || false;
    // fetch 1stmile-txn.js if needed
    var scriptSrc = "".concat(env.PROCESS_ENDPOINT, "/js/").concat(isRollback ? 'prev/' : '', "1stmile-txn.js");
    var scripts = document.querySelectorAll('#firstmile-txn');
    var isLoaded = false;
    scripts.forEach(function (script) {
        if (script.src === scriptSrc)
            isLoaded = true;
    });
    if (!isLoaded) {
        var script = document.createElement('script');
        script.id = 'firstmile-txn';
        script.src = scriptSrc;
        script.crossOrigin = 'anonymous';
        script.integrity = isRollback
            ? hashes.prev['1stmile-txn.js']
            : hashes['1stmile-txn.js'];
        script.addEventListener('load', function () {
            // wait for the script to finish loading before showing the txn view
            FirstMileTxnView.show(txn);
        });
        document.head.appendChild(script);
    }
    else {
        // Txn is already defined
        // show the Txn view
        FirstMileTxnView.show(txn);
    }
}
/**
 * Tells the ACH view to load itself
 * @param {TransactionRequest} txn
 */
function processACH(txn) {
    var _a;
    var isRollback = ((_a = txn === null || txn === void 0 ? void 0 : txn.options) === null || _a === void 0 ? void 0 : _a.rollback) || false;
    // fetch 1stmile-ach.js if needed
    var scriptSrc = "".concat(env.PROCESS_ENDPOINT, "/js/").concat(isRollback ? 'prev/' : '', "1stmile-ach.js");
    var scripts = document.querySelectorAll('#firstmile-ach');
    var isLoaded = false;
    scripts.forEach(function (script) {
        if (script.src === scriptSrc)
            isLoaded = true;
    });
    if (!isLoaded) {
        var script = document.createElement('script');
        script.id = 'firstmile-ach';
        script.src = scriptSrc;
        script.crossOrigin = 'anonymous';
        script.integrity = isRollback
            ? hashes.prev['1stmile-ach.js']
            : hashes['1stmile-ach.js'];
        script.addEventListener('load', function () {
            // wait for the script to finish loading before showing the ach view
            FirstMileACHView.show(txn);
        });
        document.head.appendChild(script);
    }
    else {
        // ACH is already defined
        // show the ACH view
        FirstMileACHView.show(txn);
    }
}
/**
 * Tells the Giftcard view to load itself
 * @param {TransactionRequest} txn
 */
function processGiftcard(txn) {
    var _a;
    var isRollback = ((_a = txn === null || txn === void 0 ? void 0 : txn.options) === null || _a === void 0 ? void 0 : _a.rollback) || false;
    // fetch 1stmile-giftcard.js if needed
    var scriptSrc = "".concat(env.PROCESS_ENDPOINT, "/js/").concat(isRollback ? 'prev/' : '', "1stmile-giftcard.js");
    var scripts = document.querySelectorAll('#firstmile-giftcard');
    var isLoaded = false;
    scripts.forEach(function (script) {
        if (script.src === scriptSrc)
            isLoaded = true;
    });
    if (!isLoaded) {
        var script = document.createElement('script');
        script.id = 'firstmile-giftcard';
        script.src = scriptSrc;
        script.crossOrigin = 'anonymous';
        script.integrity = isRollback
            ? hashes.prev['1stmile-giftcard.js']
            : hashes['1stmile-giftcard.js'];
        script.addEventListener('load', function () {
            // wait for the script to finish loading before showing the giftcard view
            FirstMileGiftcardView.show(txn);
        });
        document.head.appendChild(script);
    }
    else {
        // Giftcard is already defined
        // show the Giftcard view
        FirstMileGiftcardView.show(txn);
    }
}
/**
 * Tells the Invoice view to load itself
 * @param {TransactionRequest} txn
 */
function processInvoice(txn) {
    var _a;
    var isRollback = ((_a = txn === null || txn === void 0 ? void 0 : txn.options) === null || _a === void 0 ? void 0 : _a.rollback) || false;
    // fetch 1stmile-invoice.js if needed
    var scriptSrc = "".concat(env.PROCESS_ENDPOINT, "/js/").concat(isRollback ? 'prev/' : '', "1stmile-invoice.js");
    var scripts = document.querySelectorAll('#firstmile-invoice');
    var isLoaded = false;
    scripts.forEach(function (script) {
        if (script.src === scriptSrc)
            isLoaded = true;
    });
    if (!isLoaded) {
        var script = document.createElement('script');
        script.id = 'firstmile-invoice';
        script.src = scriptSrc;
        script.crossOrigin = 'anonymous';
        script.integrity = isRollback
            ? hashes.prev['1stmile-invoice.js']
            : hashes['1stmile-invoice.js'];
        script.addEventListener('load', function () {
            // wait for the script to finish loading before showing the invoice view
            FirstMileInvoiceView.show(txn);
        });
        document.head.appendChild(script);
    }
    else {
        // Invoice is already defined
        // show the Invoice view
        FirstMileInvoiceView.show(txn);
    }
}
/**
 * Tells the Sigcap view to load itself
 * @param {TransactionRequest} txn
 */
function processSigcap(txn) {
    var _a;
    var isRollback = ((_a = txn === null || txn === void 0 ? void 0 : txn.options) === null || _a === void 0 ? void 0 : _a.rollback) || false;
    // fetch 1stmile-sigcap.js if needed
    var scriptSrc = "".concat(env.PROCESS_ENDPOINT, "/js/").concat(isRollback ? 'prev/' : '', "1stmile-sigcap.js");
    var scripts = document.querySelectorAll('#firstmile-sigcap');
    var isLoaded = false;
    scripts.forEach(function (script) {
        if (script.src === scriptSrc)
            isLoaded = true;
    });
    if (!isLoaded) {
        var script = document.createElement('script');
        script.id = 'firstmile-sigcap';
        script.src = scriptSrc;
        script.crossOrigin = 'anonymous';
        script.integrity = isRollback
            ? hashes.prev['1stmile-sigcap.js']
            : hashes['1stmile-sigcap.js'];
        script.addEventListener('load', function () {
            // wait for the script to finish loading before showing the sigcap view
            FirstMileSigcapView.show(txn);
        });
        document.head.appendChild(script);
    }
    else {
        // Sigcap is already defined
        // show the Sigcap view
        FirstMileSigcapView.show(txn);
    }
}
/**
 * Tells the Loyalty view to load itself
 * @param {TransactionRequest} txn
 */
function processLoyalty(txn) {
    var _a;
    var isRollback = ((_a = txn === null || txn === void 0 ? void 0 : txn.options) === null || _a === void 0 ? void 0 : _a.rollback) || false;
    // fetch 1stmile-loyalty.js if needed
    var scriptSrc = "".concat(env.PROCESS_ENDPOINT, "/js/").concat(isRollback ? 'prev/' : '', "1stmile-loyalty.js");
    var scripts = document.querySelectorAll('#firstmile-loyalty');
    var isLoaded = false;
    scripts.forEach(function (script) {
        if (script.src === scriptSrc)
            isLoaded = true;
    });
    if (!isLoaded) {
        var script = document.createElement('script');
        script.id = 'firstmile-loyalty';
        script.src = scriptSrc;
        script.crossOrigin = 'anonymous';
        script.integrity = isRollback
            ? hashes.prev['1stmile-loyalty.js']
            : hashes['1stmile-loyalty.js'];
        script.addEventListener('load', function () {
            // wait for the script to finish loading before showing the loyalty view
            FirstMileLoyaltyView.show(txn);
        });
        document.head.appendChild(script);
    }
    else {
        // Loyalty is already defined
        // show the Loyalty view
        FirstMileLoyaltyView.show(txn);
    }
}
/**
 * Tells the MerchantInfoView to load itself onto the dom
 * @param {TransactionRequest} txn
 */
function processMerchantInfo(txn) {
    var _a;
    var isRollback = ((_a = txn === null || txn === void 0 ? void 0 : txn.options) === null || _a === void 0 ? void 0 : _a.rollback) || false;
    // fetch 1stmile-merchantinfo.js if needed
    var scriptSrc = "".concat(env.PROCESS_ENDPOINT, "/js/").concat(isRollback ? 'prev/' : '', "1stmile-merchantinfo.js");
    var scripts = document.querySelectorAll('#firstmile-merchantinfo');
    var isLoaded = false;
    scripts.forEach(function (script) {
        if (script.src === scriptSrc)
            isLoaded = true;
    });
    if (!isLoaded) {
        var script = document.createElement('script');
        script.id = 'firstmile-merchantinfo';
        script.src = scriptSrc;
        script.crossOrigin = 'anonymous';
        script.integrity = isRollback
            ? hashes.prev['1stmile-merchantinfo.js']
            : hashes['1stmile-merchantinfo.js'];
        script.addEventListener('load', function () {
            // wait for the script to finish loading before showing the merchantinfo view
            FirstMileMerchantInfoView.show(txn);
        });
        document.head.appendChild(script);
    }
    else {
        // MerchantInfoView is already defined
        // show the merchantinfo view
        FirstMileMerchantInfoView.show(txn);
    }
}
/**
 * Tells the T2AuthView to load itself onto the dom
 * @param {TransactionRequest} txn
 */
function processT2Auth(txn) {
    var _a;
    var isRollback = ((_a = txn === null || txn === void 0 ? void 0 : txn.options) === null || _a === void 0 ? void 0 : _a.rollback) || false;
    // fetch 1stmile-t2auth.js if needed
    var scriptSrc = "".concat(env.PROCESS_ENDPOINT, "/js/").concat(isRollback ? 'prev/' : '', "1stmile-t2auth.js");
    var scripts = document.querySelectorAll('#firstmile-t2auth');
    var isLoaded = false;
    scripts.forEach(function (script) {
        if (script.src === scriptSrc)
            isLoaded = true;
    });
    if (!isLoaded) {
        var script = document.createElement('script');
        script.id = 'firstmile-t2auth';
        script.src = scriptSrc;
        script.crossOrigin = 'anonymous';
        script.integrity = isRollback
            ? hashes.prev['1stmile-t2auth.js']
            : hashes['1stmile-t2auth.js'];
        script.addEventListener('load', function () {
            // wait for the script to finish loading before showing the T2AuthView
            FirstMileT2AuthView.show(txn);
        });
        document.head.appendChild(script);
    }
    else {
        // T2AuthView is already defined
        // show the t2auth view
        FirstMileT2AuthView.show(txn);
    }
}
/**
 * Tells the T2PayView to load itself onto the dom
 * @param {TransactionRequest} txn
 */
function processT2Pay(txn) {
    var _a;
    var isRollback = ((_a = txn === null || txn === void 0 ? void 0 : txn.options) === null || _a === void 0 ? void 0 : _a.rollback) || false;
    // fetch 1stmile-t2pay.js if needed
    var scriptSrc = "".concat(env.PROCESS_ENDPOINT, "/js/").concat(isRollback ? 'prev/' : '', "1stmile-t2pay.js");
    var scripts = document.querySelectorAll('#firstmile-t2pay');
    var isLoaded = false;
    scripts.forEach(function (script) {
        if (script.src === scriptSrc)
            isLoaded = true;
    });
    if (!isLoaded) {
        var script = document.createElement('script');
        script.id = 'firstmile-t2pay';
        script.src = scriptSrc;
        script.crossOrigin = 'anonymous';
        script.integrity = isRollback
            ? hashes.prev['1stmile-t2pay.js']
            : hashes['1stmile-t2pay.js'];
        script.addEventListener('load', function () {
            // wait for the script to finish loading before showing the T2PayView
            FirstMileT2PayView.show(txn);
        });
        document.head.appendChild(script);
    }
    else {
        // T2PayView is already defined
        // show the t2pay view
        FirstMileT2PayView.show(txn);
    }
}
/**
 * Tells the T2PayView to load itself onto the dom
 * @param {TransactionRequest} txn
 */
function processToken(txn) {
    var _a;
    var isRollback = ((_a = txn === null || txn === void 0 ? void 0 : txn.options) === null || _a === void 0 ? void 0 : _a.rollback) || false;
    // fetch 1stmile-token.js if needed
    var scriptSrc = "".concat(env.PROCESS_ENDPOINT, "/js/").concat(isRollback ? 'prev/' : '', "1stmile-token.js");
    var scripts = document.querySelectorAll('#firstmile-token');
    var isLoaded = false;
    scripts.forEach(function (script) {
        if (script.src === scriptSrc)
            isLoaded = true;
    });
    if (!isLoaded) {
        var script = document.createElement('script');
        script.id = 'firstmile-token';
        script.src = scriptSrc;
        script.crossOrigin = 'anonymous';
        script.integrity = isRollback
            ? hashes.prev['1stmile-token.js']
            : hashes['1stmile-token.js'];
        script.addEventListener('load', function () {
            // wait for the script to finish loading before showing the TokenView
            FirstMileTokenView.show(txn);
        });
        document.head.appendChild(script);
    }
    else {
        // TokenView is already defined
        // show the token view
        FirstMileTokenView.show(txn);
    }
}
/**
 * Tells the Utilities view to load itself onto the dom
 * @param {TransactionRequest} txn
 */
function processUtilities(txn) {
    var _a;
    var isRollback = ((_a = txn === null || txn === void 0 ? void 0 : txn.options) === null || _a === void 0 ? void 0 : _a.rollback) || false;
    // fetch 1stmile-util.js if needed
    var scriptSrc = "".concat(env.PROCESS_ENDPOINT, "/js/").concat(isRollback ? 'prev/' : '', "1stmile-util.js");
    var scripts = document.querySelectorAll('#firstmile-util');
    var isLoaded = false;
    scripts.forEach(function (script) {
        if (script.src === scriptSrc)
            isLoaded = true;
    });
    if (!isLoaded) {
        var script = document.createElement('script');
        script.id = 'firstmile-util';
        script.src = scriptSrc;
        script.crossOrigin = 'anonymous';
        script.integrity = isRollback
            ? hashes.prev['1stmile-util.js']
            : hashes['1stmile-util.js'];
        script.addEventListener('load', function () {
            // wait for the script to finish loading before showing the UtilitiesView
            FirstMileUtilView.show(txn);
        });
        document.head.appendChild(script);
    }
    else {
        // UtilView is already defined
        // show the Utilities view
        FirstMileUtilView.show(txn);
    }
}
/**
 * Adds the meta tag with required content for
 * mobile/responsive UI to the client <head/> if not present.
 */
var enforceMetaTag = function () {
    var found = false;
    var meta = document.querySelectorAll('meta[name="viewport"]');
    meta.forEach(function (tag) {
        var _a;
        if ((_a = tag.getAttribute('content')) === null || _a === void 0 ? void 0 : _a.includes('width=device-width'))
            found = true; // The meta tag we need exists.
    });
    if (found)
        return;
    var newMetaTag = document.createElement('meta');
    newMetaTag.name = 'viewport';
    newMetaTag.content = 'width=device-width, initial-scale=1, shrink-to-fit=no';
    document.head.appendChild(newMetaTag);
};
/**
 * Loads the hash manifest from the server.
 * @param {TransactionRequest} t The ISV transaction request.
 */
var loadHashes = function (t) { return __awaiter(void 0, void 0, void 0, function () {
    var token, serialNum, clientID, body, resp, data, _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                token = t.token, serialNum = t.serialNum;
                clientID = Math.random().toString(36).substring(2) + Math.random().toString(36).substring(2);
                body = {
                    token: token,
                    serialNum: serialNum,
                    clientID: clientID,
                    transactionType: 'GetHashValues',
                };
                _b.label = 1;
            case 1:
                _b.trys.push([1, 4, , 5]);
                return [4 /*yield*/, fetch("".concat(env.PROCESS_ENDPOINT, "/api/util"), {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify(body),
                    })];
            case 2:
                resp = _b.sent();
                // Check if the response is OK (status in the range 200-299)
                if (!resp.ok) {
                    throw new Error("HTTP error! status: ".concat(resp.status));
                }
                return [4 /*yield*/, resp.json()];
            case 3:
                data = _b.sent();
                hashes = __assign({}, data.result);
                return [3 /*break*/, 5];
            case 4:
                _a = _b.sent();
                throw new Error('Error retrieving hashes');
            case 5: return [2 /*return*/];
        }
    });
}); };
var tooManyRequestsError = {
    success: false,
    message: 'Too Many Requests',
    result: [{ status: 'Error', additionalDetails: { message: 'Transaction in progress.' } }],
    responseCode: 429,
};
/**
 * Hands off the request to the previous Cloud instance 'rollback'.
 * @param {TransactionRequest} txnRequest The ISV transaction request
 * @param {string} version The version of the 1stmile.js script, or empty string.
 * @returns {Promise<any>} The transaction response.
 */
var handleRollBackTransaction = function (transactionRequest, version) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, new Promise(function (resolve, reject) {
                var script = document.createElement('script');
                script.src = "".concat(env.PROCESS_PREV_ENDPOINT, "/js/prev/1stmile").concat(version ? "-".concat(version) : '', ".js");
                script.id = 'firstmile-prev-js';
                script.addEventListener('load', function () { return __awaiter(void 0, void 0, void 0, function () {
                    var result, error_1;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                if (!(typeof PrevFirstMile === 'object')) return [3 /*break*/, 5];
                                _a.label = 1;
                            case 1:
                                _a.trys.push([1, 3, , 4]);
                                return [4 /*yield*/, PrevFirstMile.process(transactionRequest, true)];
                            case 2:
                                result = _a.sent();
                                resolve(result);
                                return [3 /*break*/, 4];
                            case 3:
                                error_1 = _a.sent();
                                reject(error_1);
                                return [3 /*break*/, 4];
                            case 4: return [3 /*break*/, 6];
                            case 5:
                                reject(new Error('process function not found.'));
                                _a.label = 6;
                            case 6: return [2 /*return*/];
                        }
                    });
                }); });
                script.addEventListener('error', function () {
                    var errorMessage = "Failed to load script: ".concat(script.src);
                    var error = new Error(errorMessage);
                    reject(error);
                });
                document.body.appendChild(script);
            })];
    });
}); };
/**
 * Checks to see if the client is trying to load a specific version of 1stmile.js
 * Used for rollback.
 * @param {string} scriptSrc The source of the script to be checked
 * @returns The version of the 1stmile.js script that the client intends to load.
 */
var checkForVersion = function (scriptSrc) {
    var versionedJsRegex = /\/1stmile-(\d+\.\d+\.\d+)\.js$/;
    // Example string to test
    var filename = scriptSrc;
    // Use `match` to extract the version number
    if (filename) {
        var match = filename.match(versionedJsRegex);
        if (match) {
            var version = match[1];
            return version;
        }
    }
    return '';
};
var removePrevScriptFromDOM = function () {
    var prevScript = document.getElementById('firstmile-prev-js');
    prevScript === null || prevScript === void 0 ? void 0 : prevScript.remove();
};
/**
 * Process a 1stMILE request.
 * @param {TransactionRequest} t
 * @returns {Promise}
 */
export function process(t) {
    var _a;
    return __awaiter(this, void 0, void 0, function () {
        var error_2, transactionRequest, scripts, i;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    // make sure the client doesn't already have a transaction in progress.
                    if (processingFMCloudTransaction.isProcessing)
                        return [2 /*return*/, tooManyRequestsError];
                    processingFMCloudTransaction.start();
                    enforceMetaTag();
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, loadHashes(t)];
                case 2:
                    _b.sent();
                    return [3 /*break*/, 4];
                case 3:
                    error_2 = _b.sent();
                    return [2 /*return*/, {
                            success: false,
                            message: 'Error',
                            result: [
                                { status: 'Error', additionalDetails: { message: 'Error retrieving hash values.' } },
                            ],
                            responseCode: 500,
                        }];
                case 4:
                    transactionRequest = t;
                    scripts = document.getElementsByTagName('script');
                    for (i = 0; i < scripts.length; ++i) {
                        // if we're loading the sandbox script, add a parameter to the Transaction object
                        if ((_a = scripts[i].getAttribute('src')) === null || _a === void 0 ? void 0 : _a.includes('sandbox')) {
                            // client is loading sandbox script
                            transactionRequest.isSandbox = true;
                        }
                    }
                    _b.label = 5;
                case 5:
                    _b.trys.push([5, , 7, 8]);
                    return [4 /*yield*/, new Promise(function (resolve) {
                            var _a;
                            var txn = transactionRequest;
                            // based on the transactionType, present the appropriate view
                            // default transactionType to a Sale
                            switch ((_a = txn.transactionType) === null || _a === void 0 ? void 0 : _a.toLowerCase()) {
                                // case 'accountlookup':
                                // case 'accountpayment':
                                //   (<any>window).handleFMAccount = (result: object) => {
                                //     FirstMileAccountView.remove();
                                //     resolve(result);
                                //   };
                                //   processAccount(txn);
                                //   break;
                                // case 'checkrefund':
                                // case 'checkvoid':
                                // case 'void':
                                // case 'post':
                                //   (<any>window).handleFMTxn = (result: object) => {
                                //     FirstMileTxnView.remove();
                                //     resolve(result);
                                //   };
                                //   processTxn(txn);
                                //   break;
                                case 'credit':
                                case 'refund':
                                    window.handleFMCredit = function (result) {
                                        FirstMileCreditView.remove();
                                        resolve(result);
                                    };
                                    processCredit(txn);
                                    break;
                                // case 'checksale':
                                //   (<any>window).handleFMACH = (result: object) => {
                                //     FirstMileACHView.remove();
                                //     resolve(result);
                                //   };
                                //   processACH(txn);
                                //   break;
                                case 'acceptquickscreen':
                                case 'creditdecision':
                                case 'creditfacility':
                                case 'declinequickscreen':
                                case 'quickscreen':
                                    window.handleFMCreditFacility = function (result) {
                                        FirstMileCreditFacilityView.remove();
                                        resolve(result);
                                    };
                                    processCreditFacility(txn);
                                    break;
                                // case 'giftcardactivate':
                                // case 'giftcardaddvalue':
                                // case 'giftcardbalance':
                                // case 'giftcarddeactivate':
                                //   (<any>window).handleFMGiftcard = (result: object) => {
                                //     FirstMileGiftcardView.remove();
                                //     resolve(result);
                                //   };
                                //   processGiftcard(txn);
                                //   break;
                                case 'terminalprompt':
                                case 'signaturecapture':
                                    window.handleFMSigcap = function (result) {
                                        FirstMileSigcapView.remove();
                                        resolve(result);
                                    };
                                    processSigcap(txn);
                                    break;
                                case 'texttoapply':
                                    window.handleFMApply = function (result) {
                                        FirstMileApplyView.remove();
                                        resolve(result);
                                    };
                                    processApply(txn);
                                    break;
                                // case 'invoiceupload':
                                //   (<any>window).handleFMInvoice = (result: object) => {
                                //     FirstMileInvoiceView.remove();
                                //     resolve(result);
                                //   };
                                //   processInvoice(txn);
                                //   break;
                                case 'loyalty':
                                    window.handleFMLoyalty = function (result) {
                                        FirstMileLoyaltyView.remove();
                                        resolve(result);
                                    };
                                    processLoyalty(txn);
                                    break;
                                case 'retrievemerchantinfo':
                                    window.handleFMMerchantInfo = function (result) {
                                        FirstMileMerchantInfoView.remove();
                                        resolve(result);
                                    };
                                    processMerchantInfo(txn);
                                    break;
                                case 'texttoauthorize':
                                    window.handleFMT2Auth = function (result) {
                                        FirstMileT2AuthView.remove();
                                        resolve(result);
                                    };
                                    processT2Auth(txn);
                                    break;
                                case 'texttopay':
                                    window.handleFMT2Pay = function (result) {
                                        FirstMileT2PayView.remove();
                                        resolve(result);
                                    };
                                    processT2Pay(txn);
                                    break;
                                // case 'tokenadd':
                                // case 'tokenlookup':
                                //   (<any>window).handleFMToken = (result: object) => {
                                //     FirstMileTokenView.remove();
                                //     resolve(result);
                                //   };
                                //   processToken(txn);
                                //   break;
                                case 'utilities':
                                    window.handleFMUtil = function (result) {
                                        FirstMileUtilView.remove();
                                        resolve(result);
                                    };
                                    processUtilities(txn);
                                    break;
                                case 'estimatesurcharge':
                                case '':
                                case 'cashothersale':
                                case 'createtexttopay':
                                case 'sale': {
                                    // case 'Sale'/'Auth':
                                    // initiate the callback to handle the 1stMILE result and resolve the promise
                                    window.handleFMSale = function (result) {
                                        FirstMileSaleView.remove();
                                        resolve(result);
                                    };
                                    processSale(txn);
                                    break;
                                }
                                default:
                                    resolve({
                                        success: true,
                                        message: 'ok',
                                        result: [
                                            { status: 'None', additionalDetails: { message: 'Invalid transaction type.' } },
                                        ],
                                        responseCode: 200,
                                    });
                                    break;
                            }
                        })];
                case 6: return [2 /*return*/, _b.sent()];
                case 7:
                    processingFMCloudTransaction.end();
                    return [7 /*endfinally*/];
                case 8: return [2 /*return*/];
            }
        });
    });
}
export default process;
